import React, { useState, useEffect } from "react";
import styled from "styled-components";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/BackgroundAsImageWithCenteredContent.js";
import Features from "components/features/VerticalWithAlternateImageAndText.js";
import Blog from "components/blogs/ThreeColSimpleWithImage.js";
import Testimonial from "components/testimonials/TwoColumnWithImage.js";
import ContactUsForm from "components/forms/SimpleContactUs.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import Loader from "helpers/loader.js"; // Importa el Loader
import ScrollToTop from "components/scrolltotop.js"; // Ajusta la ruta si es necesario


const Container = styled.div`
  background-color: black;
  color: white; /* Opcional: Si quieres que el texto sea blanco sobre fondo negro */
  min-height: 100vh;
  position: relative;
`;

const MainLandingPage = () => {
  const [loading, setLoading] = useState(true); // Estado para el loader

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // Simula una carga de 2 segundos

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />; // Muestra el loader mientras la página se está cargando
  }

  return (
    <Container>
      <AnimationRevealPage id="inicio">
        <Hero />
        <Features />
        <div id="blog">
          <Blog />
        </div>
        <div id="sets">
          <Testimonial />
        </div>
        <div id="contacto">
        </div>
        <ScrollToTop />
        <Footer />
      </AnimationRevealPage>
    </Container>
  );
};

export default MainLandingPage;
